import { History } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Badge from "../../components/ui/Badge";
import { useDemo } from "../../providers/DemoProvider";
import { formatShortDate, getScopeLabel } from "../../services/demoSelectors";

export default () => {
  const { state } = useDemo();
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-xl font-semibold tracking-tight text-slate-900">History</h2>
          <p className="text-xs font-semibold text-slate-400">System Interaction Log</p>
        </div>
      </div>

      <div className="overflow-hidden rounded-3xl border border-slate-100 bg-white shadow-sm">
        <table className="w-full text-sm">
          <thead className="border-b border-slate-100 bg-slate-50 text-left text-xs font-semibold text-slate-400">
            <tr>
              <th className="px-6 py-4">Session Context</th>
              <th className="px-6 py-4">Scope</th>
              <th className="px-6 py-4">Nodes</th>
              <th className="px-6 py-4 text-right">Synchronization</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-50">
            {state.chatThreads.map(thread => (
              <tr key={thread.id} className="group cursor-pointer transition-colors hover:bg-slate-50/50" onClick={() => navigate("/dashboard/chat")}>
                <td className="px-6 py-5">
                  <div className="flex items-center gap-3">
                    <History className="h-4 w-4 text-slate-300 transition-colors group-hover:text-indigo-500" />
                    <span className="font-bold text-slate-700 group-hover:text-slate-900">{thread.title || "Untitled Operation"}</span>
                  </div>
                </td>
                <td className="px-6 py-5 text-xs font-bold text-slate-400">{getScopeLabel(state, thread.scope)}</td>
                <td className="px-6 py-5"><Badge tone="neutral" label={`${thread.messages.length} pkts`} size="sm" /></td>
                <td className="px-6 py-5 text-right font-mono text-xs font-bold text-slate-400">{formatShortDate(thread.updatedAt)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
